<script setup lang="ts">
window.opener?.postMessage("success", window.location.origin);
window.close();
</script>

<template>
  <div>処理の完了を待っています。しばらくおまちください......</div>
</template>
